<template>
  <div class="detail-page">
    <!-- 头部面包屑以及文字，和编辑功能 -->

    <BreadCrumb :data="breadcrumb" :title="'学者详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <!-- 学者详情页基本信息 -->
    <div v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgBox">
          <img
            v-if="scholarDetail.profile_image"
            :src="scholarDetail.profile_image"
            alt=""
            class="form-content-img"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img no-img"
          />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="one-third">
            <h4>中文名</h4>
            <span>{{ scholarDetail.chinese_name }}</span>
          </li>
          <li class="one-third">
            <h4>英文名</h4>
            <span>{{ scholarDetail.english_name }}</span>
          </li>
          <li class="one-third">
            <h4>WUPEN联盟</h4>
            <el-switch
              v-model="scholarDetail.wupen_flag"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
          <li class="one-third">
            <h4>所属院校/机构</h4>
            <span>{{
              scholarDetail.university && scholarDetail.university.chinese_name
                ? scholarDetail.university.chinese_name
                : "暂无"
            }}</span>
          </li>
          <li class="one-third">
            <h4>职称</h4>
            <span>{{
              scholarDetail.title && scholarDetail.title.english_name
                ? scholarDetail.title.english_name
                : "暂无"
            }}</span>
          </li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="scholarDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
          <li class="one-third">
            <h4>课程系列</h4>
            <span v-for="(item, index) in scholarDetail.subject" :key="index"
              >{{ index != 0 ? "," : "" }}{{ item.chinese_name }}</span
            >
          </li>
          <li class="half">
            <h4>资料来源</h4>
            <span>{{
              scholarDetail.source ? scholarDetail.source : "暂无"
            }}</span>
          </li>
          <li class="exclusive">
            <h4>简介</h4>
            <span
              v-if="scholarDetail.introduce != null"
              v-html="scholarDetail.introduce"
            ></span>
            <span v-if="scholarDetail.introduce == null">暂无</span>
          </li>
          <li class="exclusive">
            <h4>国籍</h4>
            <span>{{
              scholarDetail.nationality ? scholarDetail.nationality : "暂无"
            }}</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 修改学者详情基本信息页 -->
    <div v-show="isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgbox">
          <UploadImage
            :img="scholarDetail.profile_image"
            :width="168"
            :height="200"
            @getUploadImage="getUploadImage"
          ></UploadImage>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文名<span>*</span></h4>
            <el-input
              v-model="scholarDetail.chinese_name"
              placeholder="请输入中文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>英文名<span>*</span></h4>
            <el-input
              v-model="scholarDetail.english_name"
              placeholder="请输入英文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>资料来源</h4>
            <el-input v-model="scholarDetail.source"></el-input>
          </li>
          <li class="exclusive">
            <h4>简介</h4>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="scholarDetail.introduce"
            >
            </el-input>
          </li>

          <li class="half">
            <h4>所属院校/机构<span>*</span></h4>

            <el-autocomplete
              v-model="scholarDetail.university.chinese_name"
              :fetch-suggestions="searchUniversity"
              @select="handleSelect"
              placeholder="选择院校"
            >
            </el-autocomplete>
          </li>
          <li class="half">
            <h4>职称/职位<span>*</span></h4>
            <el-select
              v-model="scholarDetail.title.id"
              clearable
              placeholder="职称"
              class="tag"
            >
              <el-option
                v-for="(item, index) in titleList"
                :key="index"
                :label="item.english_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </li>

          <li class="half">
            <h4>国籍</h4>
            <el-select
              v-model="scholarDetail.nationality"
              placeholder="选择国籍"
              clearable
              class="tag"
            >
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.country"
                :value="item.country"
              ></el-option>
            </el-select>
          </li>
          <li class="half">
            <h4>课程系列</h4>
            <el-select
              v-model="scholarDetail.subject"
              multiple
              placeholder="请选择"
              value-key="chinese_name"
            >
              <el-option
                v-for="item in subjectList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>
          <li class="one-third">
            <h4>WUPEN联盟</h4>
            <el-switch
              v-model="scholarDetail.wupen_flag"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="scholarDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <!-- 学者详情页学者标签 -->
    <div class="pc-dataDetail-tags">
      <h2>学者标签</h2>
      <div class="input" v-if="isEditting">
        <keywordsinput
          :maxLen="18"
          v-model="scholarDetail.tags"
        ></keywordsinput>
      </div>
      <div v-else class="show">
        <p v-for="(tag, index) in scholarDetail.tags" :key="index">
          {{ tag }}
        </p>
      </div>
    </div>
    <div class="pc-dataDetail-intro">
      <h2>学者介绍</h2>
     
        <div class="content">
          <h4>中文简介</h4>
          <el-input
            type="textarea"
            v-if="isEditting"
            :rows="15"
            placeholder="请输入内容"
            v-model="scholarDetail.chinese_detail_info"
          >
          </el-input>
          <p v-else>
            {{scholarDetail.chinese_detail_info}}
          </p>
        </div>
        <TranslateText
          class="translate-btn"
          v-if="isEditting"
          :chinese="scholarDetail.chinese_detail_info"
          :english="scholarDetail.english_detail_info"
          @returnTranslate="returnTranslate"
        />
        <div class="content">
          <h4>英文简介</h4>
          <el-input
            v-if="isEditting"
            type="textarea"
            :rows="15"           
            placeholder="请输入内容"
            v-model="scholarDetail.english_detail_info"
          >
          </el-input>
          <p v-else>
            {{scholarDetail.english_detail_info}}
          </p>
        </div>
  
    </div>
    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>
<script>
import BreadCrumb from "@/components/componentSet/BreadCrumb";
import UploadImage from "../../componentSet/uploadImage.vue";
import SaveGroup from "../../componentSet/SaveGroup.vue";
import {
  scholarUniversityDropDown_Api,
  searchScholar_Api,
  ScholarTitleTopics_Api,
  addScholar_Api,
  updateScholar_Api,
  ScholarCountryTopics_Api,
  scholarSubjectDropDown_Api,
} from "@/apis/scholar.api";
import TagDetail from "@/components/template/TagDetail";
import TranslateText from "../../componentSet/TranslateText.vue";
export default {
  components: {
    UploadImage,
    BreadCrumb,
    SaveGroup,
    TagDetail,
    TranslateText,
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        { name: "学者列表", link: "/admin/scholarlist" },
        {
          name: `${
            (
              this.scholarDetail.chinese_name
                ? this.scholarDetail.chinese_name
                : this.scholarDetail.english_name
            )
              ? this.scholarDetail.chinese_name
                ? this.scholarDetail.chinese_name
                : this.scholarDetail.english_name
              : ""
          }`,
          link: "/admin/scholardetail",
        },
      ];
    },
  },
  data() {
    return {
      isEditting: true,
      scholarDetail: {
        id: null,
        tags: [],
        university: { chinese_name: "" },
        title: { english_name: "" },
        chinese_detail_info: "",
        english_detail_info: "",
      },
      title: {},
      titleList: [],
      countryList: [],
      subject: [],
      subjectList: [],
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.method == "update") {
      this.scholarDetail.id = this.$route.query.id;
      this.getScholarDetail();
    }
    ScholarCountryTopics_Api().then((res) => {
      this.countryList = res.data;
      console.log(this.countryList);
    });
    ScholarTitleTopics_Api().then((res) => {
      this.titleList = res.data;
      console.log(this.titleList);
    });
    scholarSubjectDropDown_Api().then((res) => {
      this.subjectList = res.data;
      console.log(this.subjectList);
    });
  },

  methods: {
    returnTranslate(data, flag) {
      flag == 1
        ? (this.scholarDetail.english_detail_info = data)
        : (this.scholarDetail.chinese_detail_info = data);
      console.log(data);
      console.log(flag);
    },
    handleSelect(item) {
      this.scholarDetail.university = item;
    },

    searchUniversity(queryString, callback) {
      scholarUniversityDropDown_Api(queryString ? queryString : "").then(
        (res) => {
          for (let i of res.data) {
            i.value = i.chinese_name;
          }
          this.universityList = res.data;
          callback(this.universityList);
        }
      );
    },
    getUploadImage(img_url) {
      this.scholarDetail.profile_image = img_url;
    },
    getScholarDetail(hint) {
      searchScholar_Api(this.scholarDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        this.scholarDetail = res.data;
        this.scholarDetail.university == null
          ? (this.scholarDetail.university = { chinese_name: "" })
          : "";
        this.scholarDetail.title == null
          ? (this.scholarDetail.title = { english_name: "" })
          : "";
        if (this.scholarDetail.title) {
          this.scholarDetail.title == null ? this.scholarDetail.title : "";
        }
        if (!this.scholarDetail.publish_time) {
          this.scholarDetail.publish_time = this.$dtime(new Date()).format(
            "YYYY-MM-DD"
          );
        }
        if (this.scholarDetail.position) {
          this.scholarDetail.offline = 1;
        }
        console.log(this.scholarDetail);
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getScholarDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getScholarDetail("恢复成功");
    },
    view() {
      window.open("http://wupen.org/scholar/" + this.$route.query.id, "_blank");
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.scholarDetail);
      if (!formattedData) {
        return;
      } else {
        addScholar_Api(formattedData)
          .then((res) => {
            this.scholarDetail.id = res.data.id;
            this.isEditting = false;
            this.getScholarDetail();
            this.$router.push({
              path: "/admin/scholardetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.scholarDetail);
      if (!formattedData) {
        return;
      } else {
        updateScholar_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getScholarDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    // 点击编辑
    edit() {
      this.isEditting = true;
    },
    validateForm(formData) {
      //表单校验
      if (!formData.chinese_name || !formData.english_name) {
        this.$global.error(this, "请输入中英文标题");
        return false;
      }
      if (formData.university && formData.university.chinese_name) {
        formData.university_id = formData.university.id;
      } else {
        formData.university_id = null;
      }
      if (formData.title && formData.title.id) {
        formData.title_id = formData.title.id;
      } else {
        formData.title_id = null;
      }
      if (formData.subject) {
        formData.subject_id = formData.subject.map((item) => {
          return item.id;
        });
      }
      formData.scholar_id = formData.id;
      formData.keywords = formData.tags;
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.imgBox {
  width: 200px;
  height: 200px;
}

/deep/ .el-select {
  width: 100%;
}
.imgBox .form-content-img {
  width: 100%;
  height: 100%;
}
.no-img {
  width: 200px !important;
  height: 150px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/scholar/ScholarDetail.vue